
export class WorkerPool{
	constructor(){
		this.workers = {};
		// 每个 worker url 的池上限，防止并发高峰时池数组无限增长。
		// 实际并发由 Potree.maxNodesLoading 间接限制，此处软上限作为安全阀。
		this.workerLimit = 16;
	}

	getWorker(url){
		if (!this.workers[url]){
			this.workers[url] = [];
		}

		if (this.workers[url].length === 0){
			let worker = new Worker(url);
			this.workers[url].push(worker);
		}

		let worker = this.workers[url].pop();

		return worker;
	}

	returnWorker(url, worker){
		if (!this.workers[url]){
			this.workers[url] = [];
		}
		// 超过上限时终止多余的 worker，避免池数组无限增长
		if (this.workers[url].length >= this.workerLimit){
			worker.terminate();
			return;
		}
		this.workers[url].push(worker);
	}

	// 终止所有 worker 并清空池，供 viewer 销毁/点云全部卸载时调用
	terminateAll(){
		for (const url in this.workers){
			for (const worker of this.workers[url]){
				worker.terminate();
			}
			this.workers[url] = [];
		}
	}
};

//Potree.workerPool = new Potree.WorkerPool();
